(function() {
'use strict';

angular
    .module('TR')
    .controller('HotelsSitemap', HotelsSitemap);

function HotelsSitemap(
    $location,
    hotelsSitemap,
    scrollTo,
    $window,
    hotelSearch,
    resourceService
) {

    const cm = this;
    const splitedPath = $location.path().split('/');
    const path = `/${splitedPath[splitedPath.length - 2]}/hotels-in-${splitedPath[splitedPath.length - 1]}`;
    const qs = $location.search();

    cm.size = 100;
    cm.page = page;
    cm.currentPage = qs.pi ? parseInt(qs.pi) + 1 : 1;
    cm.updating = false;
    hotelSearch.getDestinationTitle()
        .then(title => {
            cm.propertyTitle = title;
            document.title = `${title} ${resourceService.get('SITEMAP_META_TITLE')}`;
        });

    function getPage(pageNum, e) {
        if (($window && $window.history) && (e && e.target)) {
            let searchString = e.target.search ? e.target.search : '';
            const newUrl = e.target.pathname + searchString;

            $location.url(newUrl);
            $location.replace();
            $window.history.pushState(null, 'any', $location.absUrl());
        }
        cm.updating = true;

        hotelsSitemap.getHotels(path, pageNum).then(data => {
            cm.total = data.Aggregates.HotelCount;
            cm.updating = false;
            return cm.hotels = data.Hotels;
        });
    }

    getPage(cm.currentPage - 1);

    function page(num, e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        getPage(num - 1, e);
        scrollTo('body');
    }
}
})();
